var displayedCount = 12; // 初期表示するレシピ数
  var loadMoreCount = 12; // 追加で表示するレシピ数
  var allRecipes = document.querySelectorAll('.recipeDetails');
  var loadMoreButton = document.getElementById('loadMoreBtn');

  // 最初の表示状態を設定
  function setInitialVisibility() {
    for (var i = 0; i < allRecipes.length; i++) {
      if (i >= displayedCount) {
        allRecipes[i].style.display = 'none';
      } else {
        allRecipes[i].style.display = 'block';
      }
    }
  }

  // 最初の表示状態を設定
  setInitialVisibility();

  // 「すべてを見る」ボタンをクリックしたときに呼ばれる関数
  function loadMoreRecipes() {
    displayedCount += loadMoreCount;

    // 新しい表示数に基づいてレシピの表示を更新
    for (var i = 0; i < allRecipes.length; i++) {
      if (i < displayedCount) {
        allRecipes[i].style.display = 'block';
      }
    }

    // もし追加表示できるレシピがなくなったらボタンを非表示
    if (displayedCount >= allRecipes.length) {
      loadMoreButton.style.display = 'none';
    }
  }

  // ボタンのクリックイベントリスナーを設定
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', loadMoreRecipes);
  }